<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-1"> </span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-2">Malice in Maggody</span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-1"> </span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-1">An Arly Hanks Mystery</span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-1"> </span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-1"> </span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-1">Joan Hess</span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-1"> </span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-1"> </span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-1"> </span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-4"><img alt="logo" src="image/logo3.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Malice01.vue?69c98ba8